import { observer } from 'mobx-react-lite';
import React from 'react';
import popupMesStor from './popupMessageStore';

interface IStatePopupMessage {
    right: string;
    showMess: boolean;
}

const PopupMessage = ({}) => {
    const [state, setState] = React.useState<IStatePopupMessage>({
        right: '-100em',
        showMess: false
    });

    React.useEffect(() => {
        popupMesStor.textMessage &&
            !state.showMess &&
            setTimeout(() => {
                setState({ right: '5em', showMess: true });
            }, 20);
        !popupMesStor.textMessage && state.right === '5em' && setState({ right: '-100em', showMess: state.showMess });
    });

    const transitionEnd = () => {
        if (!popupMesStor.textMessage) setState({ showMess: false, right: state.right });
    };

    if (popupMesStor.textMessage || state.showMess) {
        return (
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '3.2em',
                    minWidth: '10em',
                    backgroundColor: '#66C3D0',
                    opacity: 0.3,
                    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
                    position: 'fixed',
                    right: state.right,
                    top: '5em',
                    transition: 'right .5s'
                }}
                onTransitionEnd={() => {
                    transitionEnd();
                }}>
                <div style={{ fontSize: '1em', fontWeight: 300, margin: '0.5em 1em' }}>{popupMesStor.textMessage}</div>
            </div>
        );
    } else return null;
};

export default observer(PopupMessage);
